import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Portfolio } from "@/components/Portfolio";
import { ServiceArea } from "@/components/ServiceArea";
import { InquiryForm } from "@/components/InquiryForm";
import { Footer } from "@/components/Footer";

export default function Home() {
    return (
        <main className="bg-bone text-espresso antialiased">
            <Nav />
            <Hero />
            <Marquee />
            <Services />
            <Portfolio />
            <ServiceArea />
            <InquiryForm />
            <Footer />
        </main>
    );
}
